"use client"

import { CloudCheck } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CloudCheckIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CloudCheckIcon = component(Icon)({ as: CloudCheck })
